import React, { useState, useEffect } from "react";
import useFilters from "hooks/useFilters";
import FileSaver from "file-saver";

import { useHistory } from "react-router-dom";
import { useStore } from "../../../../store/context";
import i18n from "i18n";

import { OrderService } from "../../../../services/OrderService";
import { PublicService } from "../../../../services/PublicService";
import { formatDateToYyyyMmDd } from "helpers/Parsers";

import AdminLayout from "../../../../components/MainApp/layouts/DesktopLayout";
import MainNotification from "../../../../components/MainApp/atoms/Notification";
import FilterPanel from "../../../../components/MainApp/organisms/Filters/FilterPanel";
import OrdersTable from "../../../../components/MainApp/organisms/Orders/RelocationOrders/Table";
import Pagination from "../../../../components/MainApp/atoms/Pagination";
import Loader from "../../../../components/MainApp/atoms/Loader";
import Search from "../../../../components/MainApp/atoms/Filters/Search";

import tableHeaders from "./data/tableHeaders";
import {
  filterData as FilterDataSource,
  filterTypeMap
} from "./data/filterData";

import { isMobile } from "../../../../helpers/Mobile";
import styles from "./RelocationOrders.module.scss";
import excel from "assets/images/excel.svg";
import excelwhite from "assets/images/excelwhite.svg";
import SimpleSearchPanel from "components/MainApp/organisms/Filters/SimpleSearchPanel";
import { NotFoundItems } from "views/Admin/components/NotFoundItems";
import { capitalize } from "helpers/utils/utils_general";

const initialFilters = {
  page_size: 10,
  search: "",
  ordering: "-created_at",
  status: undefined,
  node: undefined,
  origin: undefined,
  destination: undefined,
  date: [null, null],
};

let scrolling = false;

export const RelocationOrdersView = () => {
  const [orderFilters, setOrderFilters] = useState();
  const [noOrders, setNoOrders] = useState(false);
  const history = useHistory();
  const [loading, setloading] = useState(false);
  const [filterData, setFilterData] = useState(FilterDataSource);

  const [orders_name, setOrders_name] = useState([]);
  const [submitted, setSubmitted] = useState(false);
  // const myRef = useRef(0);

  const [
    filters,
    setFilters,
    selectedFiltersAll,
    selectedFiltersByType,
    handleApplyFilters,
    handleSearch,
    headerOrderingHandler,
    resetOrdering,
    handleFiltersChangeOrdering,
    applied,
    page,
    setPage,
    items,
    setItems,
    pager,
    setPager,
    header,
    setHeader,
    mobilePanelOpen,
    setMobilePanelOpen
  ] = useFilters(
    initialFilters,
    orderFilters,
    filterTypeMap,
    isMobile,
    tableHeaders
  );

  const headerOptions = [
    {
      icon: "icon-iconos_mas2",
      name: "add",
      handler: () => {
        history.push("/admin/orders/relocation/load");
      },
      tooltip: i18n.t("create.order")
    },
    {
      icon: "icon-iconos_mas",
      name: "add-simplifed",
      handler: () => {
        history.push("/admin/orders/relocation/simplifed");
      },
      tooltip: i18n.t("simplified.relocation")
    }
  ];

  useEffect(() => {
    // If specific role
    // filterData[1].enabled = true;
    // setFilterData(filterData);

    fillFilterData();
    OrderService.ordersCode({ "type": "REL" }).then(response => {
      setOrders_name(response);
    });
  }, []);

  useEffect(() => {
    setMobilePanelOpen(false);
    const first_load =
      JSON.stringify(initialFilters) === JSON.stringify(filters);
    filter(first_load);
    // Acomodar orden
    const keyOrdering =
      filters.ordering.charAt(0) === "-"
        ? filters.ordering.substr(1)
        : filters.ordering;
    if (keyOrdering in tableHeaders) {
      const newHeaders = { ...header };
      newHeaders[keyOrdering]["active"] = true;
      newHeaders[keyOrdering]["direction"] =
        filters.ordering === keyOrdering ? true : false;
      setHeader(newHeaders);
    }
  }, []);

  useEffect(() => {
    filter(false);
    setOrderFilters({
      filters: filters,
      selectedFiltersAll: selectedFiltersAll,
      selectedFiltersByType: selectedFiltersByType
    });
  }, [filters, page]);

  useEffect(() => {
    window.addEventListener("scroll", handleScroll, true);

    return () => {
      window.removeEventListener("scroll", handleScroll, true);
    };
  });

  const handleScroll = event => {
    if (!isMobile) return;

    if (
      event.srcElement.offsetHeight + event.target.scrollTop + 100 <
      event.srcElement.scrollHeight
    )
      return;

    if (!pager.next || submitted || scrolling) return;
    scrolling = true;

    setPage(page + 1);
  };

  const handlePagerChange = function (page) {
    setPage(page);
  };

  const filter = function (firstLoad = false) {
    // Enable result appending only for mobile infinite scrolling beyond page 1
    let append = isMobile && page > 1;
    if (!append) {
      setItems([]);
    }

    //BEFORE SUBMIT
    document.body.style.cursor = "wait";
    setSubmitted(true);
    // setErrors({})
    // setMessage({})

    const data = { ...filters, page: page };

    // Normalize array selections into comma-separated strings for API compatibility
    data["status"] = data["status"] ? data["status"].join(",") : undefined;
    data["node"] = data["node"] ? data["node"].join(",") : undefined;
    data["destination"] = data["destination"]
      ? data["destination"].join(",")
      : undefined;

    /**
     * SAFE DATE FORMATTING:
     * Parses the date range array into standardized YYYY-MM-DD parameters.
     */
    if (data["date"] && Array.isArray(data["date"]) && data["date"][0]) {
      data["from_date"] = formatDateToYyyyMmDd(data["date"][0]);
      data["from_date_to"] = data["date"][1] ? formatDateToYyyyMmDd(data["date"][1]) : undefined;
    }
    delete data["date"];

    setloading(true);
    OrderService.relocationOrders(data)
      .then(response => {
        //this.afterSubmit();
        setSubmitted(false);
        document.body.style.cursor = "default";
        scrolling = false;

        if (firstLoad && response.count === 0) {
          setNoOrders(true);
          return;
        }

        const newOrders = append
          ? [...items, ...response.results]
          : response.results;

        setloading(false);
        setItems(newOrders);
        setPager({
          next: response.next,
          previous: response.previous,
          count: response.count,
          countPages: Math.ceil(response.count / filters.page_size)
        });
      })
      .catch(e => {
        setSubmitted(false);
        document.body.style.cursor = "default";
        scrolling = false;
      });
  };

  /**
   * Fetches and maps node data for both Origin and Destination filters.
   * Also injects platform-specific ordering options for mobile users.
   */
  const fillFilterData = function () {
    let filterDataAux = [...filterData];

    PublicService.nodes().then(rta => {
      // Map API response to UI-compatible objects for 'Origin' and 'Destination'
      let options = rta.map(n => {
        n.label = n.name;
        n.selected = false;
        n.type = "node";
        n.id = n.code;
        return n;
      });
      filterDataAux[1].options = options;

      let options2 = rta.map(n => {
        n.label = n.name;
        n.selected = false;
        n.type = "dest";
        n.id = n.code;
        return n;
      });
      filterDataAux[2].options = options2;

      // Trigger a state update by creating a new array reference (immutability)
      setFilterData([...filterDataAux]);
    });

    if (isMobile) {
      filterDataAux[4] = {
        name: "ordering",
        type: "twoOption",
        options: [
          {
            selected: false,
            label: i18n.t("less.recent"),
            value: "created_at"
          }
        ],
        label: i18n.t("order.by"),
        firstOptionLabel: i18n.t("latest"),
        value: "-created_at"
      };
    }
    setFilterData(filterDataAux);
  };

  const downloadReport = () => {
    const data = { ...filters };
    data["status"] = data["status"] ? data["status"].join(",") : undefined;
    data["node"] = data["node"] ? data["node"].join(",") : undefined;
    data["destination"] = data["destination"]
      ? data["destination"].join(",")
      : undefined;

    setloading(true);
    OrderService.relocationDownloadReport(data)
      .then(blob => {
        setloading(false);
        FileSaver.saveAs(blob, "reporte.xls");
      })
      .catch(error => {
        setloading(false);
      });
  };

  const goToDetailPage = event => {
    history.push(
      `/admin/orders/relocation/details/${event.currentTarget.dataset.relocationOrderId}`
    );
  };

  const goToEditPage = event => {
    history.push(
      `/admin/orders/relocation/edit/${event.currentTarget.dataset.relocationOrderId}`
    );
  };

  const headerButtons = (
    <div
      className="excel-button"
      onClick={downloadReport}
      style={{
        width: "30px",
        cursor: "pointer",
        display: "flex",
        alignItems: "center"
      }}
    >
      <img style={{ height: "30px" }} src={isMobile ? excelwhite : excel} />{" "}
    </div>
  );

  const mobileContent = (
    <>
      <div className={styles["orders-relocation-table-filter-container"]}>
        <SimpleSearchPanel
          placeholder={i18n.t("search.by.name.or.code")}
          handleSubmit={handleSearch}
        />
        {/* <Search
          resultList={orders_name}
          placeholder={i18n.t("search.by.name.or.code")}
          searchValue={filters.search}
          handleSubmit={handleSearch}
          handleApplyFilters={handleApplyFilters}
        ></Search> */}
      </div>

      {mobilePanelOpen && (
        <div
          className={`${styles["orders-relocation-table-mobile-panel"]} ${mobilePanelOpen ? styles["opened"] : ""}`}
        >
          <FilterPanel
            resultList={orders_name}
            placeholder={i18n.t("search.by.name.or.code")}
            searchValue={filters.search}
            handleSubmitSearch={handleSearch}
            filters={filterData}
            selectedFiltersAll={selectedFiltersAll}
            selectedFiltersByType={selectedFiltersByType}
            handleApplyFilters={handleApplyFilters}
            closeMobilePanel={() => {
              setMobilePanelOpen(false);
            }}
          ></FilterPanel>
        </div>
      )}

      <div className={styles["orders-relocation-table-table"]}>
        <div className={styles["orders-relocation-table-top-table"]}>
          <div className={styles["orders-relocation-table-top-total"]}>
            {capitalize(i18n.t("total"))}{" "}
            <span className={styles["orders-relocation-table-top-total-bold"]}>
              ({pager.count})
            </span>
          </div>
          <div
            className={`${styles["orders-relocation-table-top-sort"]} ${applied ? styles["orders-relocation-table-active-filter"] : ""}`}
            onClick={() => {
              setMobilePanelOpen(true);
            }}
          >
            <i className={`icon-iconos_filtros ${styles["orders-relocation-table-top-icon"]}`}></i>
          </div>
        </div>
        <OrdersTable
          relocationOrders={items}
          headers={header}
          handleClickRelocationOrder={goToDetailPage}
          handleClickDraft={goToEditPage}
        />
      </div>

      {items.length === 0 && !submitted && (
        <NotFoundItems />
      )}
    </>
  );

  // DESKTOP START
  const desktopContent = (
    <div className={styles["orders-relocation-content-wrapper"]}>
      <FilterPanel
        resultList={orders_name}
        placeholder={i18n.t("search.by.name.or.code")}
        searchValue={filters.search}
        handleSubmitSearch={handleSearch}
        filters={filterData}
        selectedFiltersAll={selectedFiltersAll}
        selectedFiltersByType={selectedFiltersByType}
        handleApplyFilters={handleApplyFilters}
      ></FilterPanel>

      {items.length > 0 && (
        <div className={styles["orders-relocation-table-table"]}>
          <div className={styles["orders-relocation-table-top-table"]}>
            <div className={styles["orders-relocation-table-top-total"]}>
              {i18n.t("total").toUpperCase()}
              <span className={styles["orders-relocation-table-top-total-bold"]}>
                ({pager.count})
              </span>
            </div>
            <div className={styles["orders-relocation-table-top-sort"]}>
              <div
                data-automation-id="orders-relocation-table-sort"
                className={
                  filters.ordering.includes("created_at")
                    ? `${styles["orders-relocation-table-top-sort"]} ${styles["orders-relocation-table-active-filter"]}`
                    : styles["orders-relocation-table-top-sort"]
                }
                onClick={() => {
                  handleFiltersChangeOrdering(
                    "ordering",
                    filters.ordering === "-created_at"
                      ? "created_at"
                      : "-created_at"
                  );
                  resetOrdering();
                }}
              >
                {filters.ordering === "created_at" ? (
                  <React.Fragment>
                    {i18n.t("less.recent")}
                    <i className={`icon-chevron ${styles["orders-relocation-table-top-icon"]}`}></i>
                  </React.Fragment>
                ) : (
                  <React.Fragment>
                    {i18n.t("latest")}
                    <i className={`icon-chevron-down ${styles["orders-relocation-table-chevron-down"]} ${styles["orders-relocation-table-top-icon"]}`}></i>
                  </React.Fragment>
                )}
              </div>
            </div>
          </div>
          <OrdersTable
            relocationOrders={items}
            headers={tableHeaders}
            headerClickHandler={headerOrderingHandler}
            handleClickRelocationOrder={goToDetailPage}
            handleClickDraft={goToEditPage}
          />
        </div>
      )}

      {items.length === 0 && !submitted && (
        <NotFoundItems />
      )}
      {items.length > 0 && (
        <div>
          <Pagination
            pageQuantity={pager.countPages}
            currentPage={page}
            pageChangeHandler={handlePagerChange}
          />
        </div>
      )}
    </div>
  );
  // DESKTOP END

  const content = (
    <div className={styles["orders-relocation-content-container"]}>
      {isMobile ? mobileContent : desktopContent}
    </div>
  );

  return (
    <div className={styles["orders-relocation-container"]}>
      <AdminLayout
        headerTitle={i18n.t("orders.types.REL")}
        headerOptions={headerOptions}
        content={content}
        navHidden={false}
        customButtons={headerButtons}
        goBackFunc={() => {
          history.push("/admin/orders");
        }}
      ></AdminLayout>
      {loading && <Loader />}
      <MainNotification
        label={i18n.t("product.updated.successfully.message")}
        open={false}
      ></MainNotification>
    </div>
  );
};

export default RelocationOrdersView;
